import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/index",
      component: (resolve) => require(["@/views/Layout"], resolve),
    },
    {
      path: "/current_weather",
      component: (resolve) =>
        require(["@/views/current_weather/current_weather"], resolve),
      meta: {
        title: "乡镇(街道)实况",
      },
    },
    {
      path: "/current_forecast",
      component: (resolve) =>
        require(["@/views/forecast/current_forecast"], resolve),
      meta: {
        title: "同州天气",
      },
    },
    {
      path: "/weather_monitor/:id",
      component: (resolve) =>
        require(["@/views/weather_monitor/weather_monitor"], resolve),
    },
    {
      path: "/warn_category_list",
      component: (resolve: any) =>
        require(["@/views/warninfo/warn_category_list"], resolve),
      meta: {
        title: "预警信息",
      },
    },
    {
      path: "/warn_article",
      component: (resolve: any) =>
        require(["@/views/content_manage/warn_article"], resolve),
    },
    {
      path: "/important_warn_article",
      component: (resolve: any) =>
        require(["@/views/content_manage/important_warn_article"], resolve),
    },
    {
      path: "/warn_info",
      component: (resolve: any) =>
        require(["@/views/warninfo/warn_info"], resolve),
      meta: {
        title: "预警信号",
      },
    },
    {
      path: "/daily_forecast",
      component: (resolve) =>
        require(["@/views/forecast/daily_forecast"], resolve),
      meta: {
        title: "天气预报",
      },
    },
    {
      path: "/weekly_forecast",
      component: (resolve) =>
        require(["@/views/forecast/weekly_forecast"], resolve),
      meta: {
        title: "一周天气预报",
      },
    },
    {
      path: "/daily15_forecast",
      component: (resolve) =>
        require(["@/views/forecast/daily15_forecast"], resolve),
      meta: {
        title: "十五天天气预报",
      },
    },
    {
      path: "/subject_list",
      component: (resolve) =>
        require(["@/views/content_manage/subject_list"], resolve),
    },
    {
      path: "/article_details",
      component: (resolve) =>
        require(["@/views/content_manage/article_details"], resolve),
    },

    {
      path: "/pdf",
      component: (resolve) =>
        require(["@/views/content_manage/pdf_view"], resolve),
      meta: {
        title: "pdf查看",
      },
    },
    {
      path: '/weather_certificate',
      component: (resolve) => require(['@/views/weather_certificate/weather_certificate'], resolve),
      meta: {
        title: '公众互动',
      },
    },
    {
      path: '/weather_certificate/apply',
      component: (resolve) => require(['@/views/weather_certificate/Apply'], resolve),
      meta: {
        title: '证明申请',
      },
    },
    {
      path: '/weather_certificate/apply_result',
      component: (resolve) => require(['@/views/weather_certificate/ApplyResult'], resolve),
      meta: {
        title: '提交反馈',
      },
    },
    {
      path: '/weather_certificate/apply_details/:id',
      component: (resolve) => require(['@/views/weather_certificate/applyDetails'], resolve),
      meta: {
        title: '气象证明详情',
      },
    },
    {
      path: '/services/jujube_service',
      component: (resolve) => require(['@/views/services/jujube_service'], resolve),
      meta: {
        title: '冬枣气象服务',
      },
    },
  ],
});
router.beforeEach((to: any, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
